<!-- InlineEditor.vue -->
<template>
  <div class="inline-editor">
    <div v-if="!isEditing" class="display-mode">
      <span>{{ formattedDisplayValue }}</span>
      <button @click="startEdit" class="edit-btn">
        <img :src="require('@/assets/editCriteria.svg')" class=""  alt="">

      </button>
    </div>

    <div v-else class="edit-mode">
      <!-- Textarea input -->
      <textarea
        v-if="type === 'textarea'"
        ref="inputRef"
        v-model="editValue"
        :rows="rows"
        @keyup.esc="cancel"
        class="textarea-input"
      ></textarea>
      <input
        v-else-if="type == 'date'"
        ref="inputRef"
        v-model="editValue"
        :type="type"
        :min="minDate"
        @keyup.enter="confirm"
        @keyup.esc="cancel"
        class="regular-input"
      >

      <!-- Regular input (text, date, etc) -->
      <input
        v-else
        ref="inputRef"
        v-model="editValue"
        :type="type"
        @keyup.enter="confirm"
        @keyup.esc="cancel"
        class="regular-input"
      >

      <button @click="confirm" class="confirm-btn">
        Save

      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InlineEditor',
  props: {
    modelValue: {
      required: true,
      type: [String, Number, Date]
    },
    type: {
      type: String,
      default: 'text',
      validator: (value) => ['text', 'date', 'textarea', 'number', 'email'].includes(value)
    },
    rows: {
      type: Number,
      default: 3
    },
    dateFormat: {
      type: String,
      default: 'YYYY-MM-DD'
    }
  },
  emits: ['update:modelValue', 'save'],
  data() {
    return {
      isEditing: false,
      editValue: ''
    }
  },
  computed: {
    formattedDisplayValue() {
      if (this.type === 'date' && this.modelValue) {
        return this.formatDate(this.modelValue)
      }
      return this.modelValue
    },
    tomorrowDate() {
     const tomorrow = new Date()
     tomorrow.setDate(tomorrow.getDate() + 1)
     return tomorrow.toISOString().split('T')[0] // Returns YYYY-MM-DD format
   }
  },
  methods: {
    startEdit() {
      // For date type, ensure we're working with the proper format
      if (this.type === 'date' && this.modelValue) {
        this.editValue = this.formatDateForEdit(this.modelValue)
      } else {
        this.editValue = this.modelValue
      }

      this.isEditing = true
      this.$nextTick(() => {
        this.$refs.inputRef?.focus()
      })
    },
    confirm() {
      if (!this.isValid()) {
        return
      }

      this.isEditing = false
      const finalValue = this.type === 'date' ? new Date(this.editValue) : this.editValue
      this.$emit('update:modelValue', finalValue)
      this.$emit('save', finalValue)
    },
    cancel() {
      this.isEditing = false
      this.editValue = this.modelValue
    },
    isValid() {
      if (this.type === 'date') {
        return !isNaN(new Date(this.editValue).getTime())
      }
      return true
    },
    formatDate(date) {
      if (typeof date === 'string') {
        date = new Date(date)
      }
      if (date instanceof Date && !isNaN(date)) {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
         return `${day}/${month}/${year}`;
      }
      return '';
    },
    formatDateForEdit(date) {
      if (typeof date === 'string') {
        date = new Date(date)
      }
      if (date instanceof Date && !isNaN(date)) {
        return date.toISOString().split('T')[0]
      }
      return '';
    }
  }
}
</script>

<style scoped>
.inline-editor {
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
}

.display-mode {
  display: flex;
  align-items: center;
  gap: 8px;
}

.edit-mode {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex-wrap: wrap;
}

button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
}

.edit-btn {
  color: #666;
}

.confirm-btn {
background:#3783C5;
color:#FFF;
padding: 5px 20px;
border-radius:200px;
text-align:center;
display:inline-block;
margin:auto;
}

.cancel-btn {
  color: #f44336;
}

.regular-input {
  padding: 4px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 100%;
}

.textarea-input {
  padding: 4px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
width: 100%;
  resize: vertical;
}


</style>
